import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/common.css'
import './assets/css/el_style.css'
import * as echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment'
import { ElementTiptapPlugin } from 'element-tiptap'
import 'element-ui/lib/theme-chalk/index.css'
// 引入 import element-tiptap 样式
import 'element-tiptap/lib/index.css'

ElementUI.Dialog.props.lockScroll.default = false
Vue.use(VueClipboard)
Vue.use(ElementUI)
// 安装 element-tiptap 插件
Vue.use(ElementTiptapPlugin, {
	lang: 'zh' // 设置语言为中文
})
import VueAwesomeSwiper from 'vue-awesome-swiper'

import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')
